import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const getWidthValue = (props) => {
  if (props.fromCartAndCheckoutPageError) {
    return '22px';
  }
  return '20px';
};

const getTopValue = (props) => {
  if (props.fromModal) {
    return '-24px';
  }
  if (props.isGlobalHeaderRedesignEnabled) {
    return '78px';
  }
  return '0px';
};

const ErrorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${(props) => (props.isMiniError ? 'flex-start' : 'center')};
  background-color: ${(props) =>
    props.type === 'error' || props.fromCartAndCheckoutPageError ? '#c62828' : '#338B2B'};
  color: white;
  padding: ${(props) => (props.isMiniError ? '12px' : '14px 32px')};
  box-sizing: border-box;
  width: 100%;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: 12px;
    align-items: flex-start;
  }
`;
const ErrorMessage = styled.span`
  display: flex;
  width: 100%;
  align-items: ${(props) => (props.isMiniError ? 'flex-start' : 'center')};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    align-items: flex-start;
  }
`;
const StickyBanner = styled.div`
  position: sticky;
  z-index: ${(props) => (props.fromModal ? 11000 : 99)};
  top: ${(props) => getTopValue(props)};
  margin: ${(props) => (props.fromModal ? '-24px -24px 0 -24px' : '0')};
  transition: all 0.5s ease-in-out;
  opacity: ${(props) => (props.fadeOut ? 0 : 1)};
  pointer-events: ${(props) => (props.fadeOut ? 'none' : 'auto')};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) => {
      const {
        fromCartAndCheckoutPageError,
        fromAtbError,
        isHeaderStickyClassPresent,
        topVal,
        stickyHeaderHeight,
      } = props;

      if (!fromCartAndCheckoutPageError && !fromAtbError) {
        return `
          position: fixed;
          width: 100%;
          top: ${!isHeaderStickyClassPresent && topVal ? 0 : `${stickyHeaderHeight}px`};
        `;
      }
      return `
        top: ${isHeaderStickyClassPresent ? `${stickyHeaderHeight}px` : '60px'};
      `;
    }}
  }
`;

const CheckMarkIcon = styled.div`
  width: 100px;
  width: ${(props) => (props.isMiniError ? '20px' : '24px')};
  height: ${(props) => (props.isMiniError ? '20px' : '24px')};
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 20px;
    height: 20px;
  }

  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 2px;
    background-color: #338b2b;
    transform: rotate(135deg);
    border-radius: 5px;
    top: 47%;
    left: 33%;
  }

  &::after {
    content: '';
    position: absolute;
    width: 5px;
    height: 2px;
    background-color: #338b2b;
    transform: rotate(45deg);
    border-radius: 5px;
    top: 56%;
    left: 26%;
  }
`;

const TextContainer = styled(BodyCopy)`
  min-width: 270px;
  width: 80%;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 85%;
  }
`;

const InfoIconCircle = styled.span`
  box-sizing: border-box;
  display: inline-block;
  width: 24px;
  height: ${(props) => (props.isMiniError ? '20px' : '24px')};
  left: 0;
  top: 10px;
  background: white;
  border: 1px solid white;
  border-radius: 50%;
  color: #c62828;
  text-align: center;
  font-weight: 700;
  margin: ${(props) => (props.isMiniError ? '0' : '0 5px 0 0')};
  padding: ${(props) => (props.fromAtbError ? '0px' : ' 2px 0px;')};
  font-size: 15px;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: ${(props) => getWidthValue(props)};
    height: 20px;
    padding: 2px 0px;
    margin: 0;
    font-size: 12px;
  }
`;

export { ErrorContainer, ErrorMessage, StickyBanner, InfoIconCircle, CheckMarkIcon, TextContainer };
